// extracted by mini-css-extract-plugin
export default {"roundedButton":"style_roundedButton__HcXL5","circle":"style_circle__yVrLo"};